import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 350D7B60-3F36-4FB0-9959-B90625F5267C
 * name playlist-plus
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/playlist-plus.svg
 * tags
 */
export const PlaylistPlusIcon = createSvgIcon(<><path d="M3 16H10V14H3M18 14V10H16V14H12V16H16V20H18V16H22V14M14 6H3V8H14M14 10H3V12H14V10Z" /></>, 'PlaylistPlusIcon');
export default PlaylistPlusIcon